import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { getCommentBoxId } from '../../helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import CommentBoxWithSuggestions from '../../../CommentBox/presets/CommentBoxWithSuggestions';
import s from './ThreadPostbox.scss';
const ThreadPostbox = ({ commentableItemId , commentableTypeId , position , parentComment , currentUser , canPostComment , onThreadUpdated , onPublishSuccess , streamId , className , isSmall , withCommentSuggestions  })=>{
    const handleThreadUpdated = useCallback((result)=>{
        onThreadUpdated && onThreadUpdated(streamId, result);
        onPublishSuccess && onPublishSuccess(result);
    }, [
        onThreadUpdated,
        streamId,
        onPublishSuccess
    ]);
    let CommentBoxPreset = CommentBox;
    const commentBoxProps = {
        id: getCommentBoxId(commentableTypeId, commentableItemId, position),
        className: s['commentbox'],
        commentableType: commentableTypeId,
        commentableItemId: commentableItemId,
        replyComment: parentComment,
        user: currentUser,
        onPublishSuccess: handleThreadUpdated,
        canPostComment: !!canPostComment,
        isSmall
    };
    if (withCommentSuggestions) {
        CommentBoxPreset = CommentBoxWithSuggestions;
        commentBoxProps['type'] = withCommentSuggestions;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['commentbox-wrapper'], position === 'topmost' && s['commentbox-wrapper-topmost'], position === 'bottom' && s['commentbox-wrapper-bottom'], className)
    }, /*#__PURE__*/ React.createElement(CommentBoxPreset, _extends({}, commentBoxProps)));
};
ThreadPostbox.displayName = 'ThreadPostbox';
export default ThreadPostbox;
